import React from 'react'
import { Link } from 'react-router-dom'

import { concatStyles } from 'src/utils'
import { useStyles } from './styles'

interface RedirectProps {
  to: string;
  className?: string;
  children: React.ReactNode;
}

export const Redirect: React.FC<RedirectProps> = ({ children, to: path, className }) => {
  const { redirectContainer } = useStyles()
  return (
    <Link
      to={path}
      className={concatStyles(redirectContainer, className)}
      onClickCapture={(e) => {
        if (location.pathname === path) {
          e.preventDefault()
        }
      }}
    >
      {children}
    </Link>
  )
}
